export const isIE11 = /Trident\/7\./.exec(window.navigator.userAgent);
